import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _RefreshTokenRequestDtoSchema = z.object();
const RefreshTokenResponseDtoSchema = z.object({
  accessToken: z.string(),
});

export type RefreshTokenRequestDto = z.infer<
  typeof _RefreshTokenRequestDtoSchema
>;
export type RefreshTokenResponseDto = z.infer<
  typeof RefreshTokenResponseDtoSchema
>;

export const refreshToken = (
  config?: AxiosRequestConfig<RefreshTokenRequestDto>
) => {
  return api
    .post('/auth/refresh-token', {}, config)
    .then(responseContract(RefreshTokenResponseDtoSchema));
};
